import { useRef } from 'react'

export const useCreateNewDealRefs = () => {
  const dialogRef = useRef<HTMLDivElement>(null)
  const selectedOrgRef = useRef<HTMLDivElement>(null)
  const agreementOptionRef = useRef<HTMLDivElement>(null)
  const stageRef = useRef<HTMLDivElement>(null)
  const noSignatureRef = useRef<HTMLDivElement>(null)
  const typeRef = useRef<HTMLDivElement>(null)
  const nextRef = useRef<HTMLDivElement>(null)

  const stepRefs = [selectedOrgRef, agreementOptionRef, stageRef, noSignatureRef, typeRef, nextRef]
  const dealRawSteps = [
    {
      title: 'Select Organization',
      description:
        'Select the organization you wish to create a deal for.  This will create a perpetual connection between the deal and the organization ',
    },
    {
      title: 'Agreement Option',
      description:
        'Option to assign to the new contract that will be affiliated with this new deal.  Choosing New/Add-on Business creates a unique new deal.  Choosing Replace Existing Business will give options to select another deal to replace.  The deal selected will be replaced and updated to reflect this as soon as the new deal hits deal won.',
    },
    {
      title: 'Stage',
      description: 'This field represents the stage the deal will be created in.',
    },
    {
      title: 'No Signature Required',
      description:
        'This option should be selected for deals that are Completed Internally.  Choosing this option will immediately set the deal to Deal Won stage.',
    },
    {
      title: 'Type',
      description:
        'List of options representing the type of deal being created (Marketing Services Agreement (MSA), Creative Services Agreement (CSA), etc..',
    },
    {
      title: 'Next',
      description:
        'When the next button is clicked, the deal will be created and you will be routed to the deals agreement page to begin filling out the contract.',
    },
  ]
  const createNewDealSteps = dealRawSteps.map((step, index) => ({ ...step, stepIndex: index }))
  return {
    dialogRef,
    selectedOrgRef,
    agreementOptionRef,
    stageRef,
    noSignatureRef,
    typeRef,
    nextRef,
    stepRefs,
    createNewDealSteps,
  }
}
